<template>
  <div v-if="vehicle" class="vehicle-detail pt-1 pb-1">
    <div class="row mb-3">
      <div class="col-md-2">
        <p class="mb-0"><strong>{{ $t('routeOptimization.fields.name') }}</strong></p>
        <p class="mb-0">Trip 1</p>
      </div>
      <div class="col-md-3">
        <p class="mb-0"><strong>{{ $t('routeOptimization.fields.totalDelivery') }}</strong></p>
        <p class="mb-0">{{ vehicle.order_count || 0 }} Point</p>
      </div>
      <div class="col-md-3">
        <p class="mb-0"><strong>{{ $t('routeOptimization.fields.distanceDelivery') }}</strong></p>
        <p class="mb-0">{{ formatOrDash(vehicle.distance, 2, 1000) }} km</p>
      </div>
      <div class="col-md-2">
        <p class="mb-0"><strong>{{ $t('routeOptimization.fields.weight') }}</strong></p>
        <p class="mb-0">{{ formatOrDash(vehicle.total_weight) }}/{{ formatOrDash(vehicle.weight_capacity) }} kg</p>
      </div>
      <div class="col-md-2">
        <p class="mb-0"><strong>{{ $t('routeOptimization.fields.volume') }}</strong></p>
        <p class="mb-0">{{ formatOrDash(vehicle.total_volume) }}/{{ formatOrDash(vehicle.volume_capacity) }} cbm</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <p class="mb-0"><strong>{{ $t('routeOptimization.fields.pickupLocation') }}</strong></p>
        <p class="mb-0">{{ origin }}</p>
      </div>
      <div v-if="hasFeatureVehicleDistrictMgm" class="col-md-10">
        <p class="mb-0"><strong>{{ $t('routeOptimization.fields.dropLocation') }}</strong></p>
        <McChipList
          v-if="districts?.length"
          :items="districts"
          :max-visible="3"
          itemTextField="name"
          showAllMode="inline"
        />
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

import McChipList from '@/components/McChipList'

import { formatOrDash } from '@/helpers/format-number.js'

export default {
  components: {
    McChipList,
  },
  name: 'VehicleDetail',
  mixins: [Helper],
  props: {
    vehicle: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
      getFeatureStrategies: 'identity/getFeatureStrategies',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    origin() {
      return this.vehicle.timelines.find(
        (point) =>
          point.type === 'DEFAULT' &&
          point.activities?.some((act) => act.type === 'PICKUP')
      )?.address?.name
    },
    districts() {
      return this.vehicle.districts
        .map((district) => ({
          name: district
        }))
    },
    hasFeatureVehicleDistrictMgm() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return Array.isArray(data?.company_id) && data.company_id.includes(this.getCompanyId()) && data?.features?.vehicle_district
    },
  },
  methods: {
    formatDistance(distance) {
      if (!distance) return 0
      return (distance / 1000).toFixed(2)
    },
    formatOrDash,
  }
}
</script>

<style lang="scss" scoped>
.vehicle-detail {
  background-color: #f8f9fa;
}
</style>
